import React from 'react'
import { Container, Row, Col, Form } from 'react-bootstrap'
import PropTypes from 'prop-types'
import styles from './SearchComponent.module.css'
import { Box } from '@material-ui/core'

class SearchComponent extends React.Component {
  static propTypes = {
    loading: PropTypes.bool,
    searchResults: PropTypes.array,
    getSearchData: PropTypes.func,
    clearSearchData: PropTypes.func,
    handleNameFilter: PropTypes.func,
    filterValue: PropTypes.bool,
    nameFilter: PropTypes.string,
    setNameFilter: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.inputRef=React.createRef()
  }

  componentDidMount () {
    let timeout = null
    if (this.inputRef.current) {
      this.inputRef.current.addEventListener('keyup', () => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          this.props.getSearchData(this.inputRef.current.value)
        }, 500)
    })
    }
  }

  onChange = (e) => {
    if (e.target.value.length === 0) {
      this.onClear()
    }
  }

  onClear = () => {
    this.props.clearSearchData('')
    this.inputRef.current.value = ''
  }

  render () {
    return (
      <Container fluid={true} className='librarySearchFilter'>
        <Row className="flex-column">
          <Col md="auto">
            <Form className={this.props.searchResults ? 'formActive':''}>
              <Form.Group controlId="formSearch" className="position-relative mb-0 d-flex justify-content-center">
                <Box className={`${styles.searchWrapper}`}>
                  <img src='/static/images/library_search.svg' alt="search" className={`${styles.searchIcon} searchIcon`} ></img>
                </Box>
                { this.props.nameFilter.length > 0 &&
                  <Box className={`${styles.closeWrapper}`} onClick={this.onClear}>
                    <img src='/static/images/library_close.svg' alt="search" className={`${styles.closeIcon} closeIcon`} ></img>
                  </Box>
                }
                <Form.Control
                  type="text"
                  placeholder="Filter by name or keyword..."
                  className={`${styles._searchInput} form-control _searchInput`}
                  onChange={(e) => this.onChange(e)}
                  ref={this.inputRef}
                  //value={this.props.nameFilter}
                  autoComplete={'off'}
                />
                <span className={`${styles.baseLine} baseLine`}/>
              </Form.Group>
            </Form>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default SearchComponent